export enum SettingsCopilotDataEventObjectsEnum {
  SETTINGS_COPILOT_FEEDBACK = 'admin_copilot_feedback',
  SETTINGS_COPILOT_INPUT_MESSAGE = 'admin_copilot_input_message',
  SETTINGS_COPILOT_FLOATING_PANEL_OPEN = 'admin_copilot_floating_panel_open',
  SETTINGS_COPILOT_FLOATING_PANEL_COLLAPSE = 'admin_copilot_floating_panel_collapse',
  SETTINGS_COPILOT_RESTART_CONVERSATION = 'admin_copilot_restart_conversation',
  SETTINGS_COPILOT_LEGAL_MESSAGE = 'admin_copilot_legal_message',
  SETTINGS_COPILOT_LEGAL_MESSAGE_ACCEPT = 'admin_copilot_legal_message_accept',
  SETTINGS_COPILOT_REASONING_TRACE = 'admin_copilot_reasoning_trace',
}
